import dynamic from "next/dynamic";

export const Compliance = dynamic(() => import("./Compliance"), {
  ssr: false,
});

export const ModalCompliance = dynamic(() => import("./ModalCompliance"), {
  ssr: false,
});

export const ModalStakingRisk = dynamic(() => import("./ModalStakingRisk"), {
  ssr: false,
});
